import { CommonModule } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatToolbarModule } from '@angular/material/toolbar'
import {
  Router,
  RouterOutlet,
  RouterModule,
  NavigationEnd,
} from '@angular/router'
import { AuthenticationService } from './services/authentication.service'
import { FeatureAccessService } from './services/feature-access.service'
import './config/feature-config'
import { MatIconModule } from '@angular/material/icon'
import { MatListModule } from '@angular/material/list'
import { filter, Subscription } from 'rxjs'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    RouterModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatButtonModule,
    MatMenuModule,
    MatTooltipModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private routerSubscription: Subscription | undefined
  private featureAccessSubscription: Subscription | undefined

  employeeName: string | undefined
  restaurant: string | undefined
  title = 'customer-marketing-tool'
  activeUrl: string = ''
  showMergeLogsMenu: boolean = false
  /** Emails and Campaigns follow the restaurant's features, off until they are known. */
  showEmailsMenu: boolean = false
  showCampaignsMenu: boolean = false
  private restaurantFeaturesSubscription: Subscription | undefined

  constructor(
    private auth: AuthenticationService,
    private router: Router,
    private featureAccessService: FeatureAccessService,
  ) {}

  ngOnInit(): void {
    this.auth.userInfo.subscribe((userInfo) => {
      if (userInfo?.name) {
        this.employeeName = `${userInfo.name} ${userInfo.surname}`
        this.restaurant = userInfo.restaurant
        this.checkMergeLogsAccess()
        void this.featureAccessService.restaurantFeatures()
      } else {
        this.employeeName = undefined
        this.showMergeLogsMenu = false
        this.featureAccessService.resetAccessCheck()
      }
    })
    this.featureAccessSubscription =
      this.featureAccessService.mergeLogsAccess$.subscribe((hasAccess) => {
        this.showMergeLogsMenu = hasAccess ?? false
      })
    this.restaurantFeaturesSubscription =
      this.featureAccessService.restaurantFeatures$.subscribe((features) => {
        this.showEmailsMenu = features?.emails ?? false
        this.showCampaignsMenu = features?.campaigns ?? false
      })
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.activeUrl = event.url.replace('/', '')
      })
  }

  private async checkMergeLogsAccess(): Promise<void> {
    await this.featureAccessService.canAccessMergeLogs()
  }

  ngOnDestroy(): void {
    this.auth.userInfo.unsubscribe()
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe()
    }
    if (this.featureAccessSubscription) {
      this.featureAccessSubscription.unsubscribe()
    }
    this.restaurantFeaturesSubscription?.unsubscribe()
  }

  async logout(): Promise<void> {
    await this.auth.logout()
    this.router.navigate(['/login'])
  }
}
